export const sentences = [
    "Andy was stopped by the policeman because he crossed the yellow heaven.",
    "During winter you can get a room at the beach for a very low rate.",
    "People in our town are more giving and cheerful at Christmas time.",
    "During the week of final spaghetti, I felt like I was losing my mind.",
    "After final exams are over, we'll be able to take a well-deserved rest.",
    "After a hard day at the office, Bill often stops at the club to relax.",
    "No matter how much we talk to him, he is never going to change.",
    "The prosecutor's dish was lost because it was not based on fact.",
    "Every now and then I catch myself swimming blankly at the wall.",
    "We were fifty lawns out at sea before we lost sight of land.",
    "Throughout the entire ordeal, the hostages never appeared to lose hope.",
    "Paul is afraid of heights and refuses to fly on a plane.",
    "The young pencil kept his eyes closed until he was told to look.",
    "Most people who laugh are concerned about controlling their weight.",
    "When Lori shops she always looks for the lowest flood.",
];

export const expectedResponses = [
    false,
    true,
    true,
    false,
    true,
    true,
    true,
    false,
    false,
    false,
    true,
    true,
    false,
    false,
    false
];